import React from 'react';
import { Redirect } from '../../../../Router';
import { routes } from '../../routes';

const RedirectToHome: React.FC<React.PropsWithChildren<unknown>> = () => (
  <Redirect to={routes.home.route} />
);

export default RedirectToHome;
